<template>
  <div class="animated fadeIn">
    <b-row class="mt-2 mb-2">
      <b-col>
        <h2>รายละเอียดงาน</h2>
      </b-col>
      <b-col>
        <b-button
          v-if="quote.status < 20"
          class="float-right"
          @click="closeJob"
          variant="danger"
        >ปิดงาน</b-button>
        <b-button
          v-else
          class="float-right"
          @click="openJob"
          variant="warning"
        >เปิดงาน</b-button>
        <b-button
          :href="previewBaseUrl + '/' + quote._id"
          class="float-right mr-2"
          variant="primary"
          target="_blank"
        >ดูงานจริง</b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-card>
          <b-row>
            <b-col v-if="quote.shipper" sm="12" class="mb-4">
              <h5>{{ quote.goodsDescriptions }}</h5>
              <b>{{ quote.shipper.name }}</b>
              <br />
              <b>{{ quote.shipper.address }}</b>
            </b-col>
            <b-col v-else>
              <h5>ผู้ประกาศงานถูกลบ</h5>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col sm="12" md="3">
              <span class="text-muted">ลักษณะงาน</span>
              <br />
              <b>{{ quote.jobType }}</b>
            </b-col>
            <b-col sm="12" md="3">
              <span class="text-muted">วันที่เริ่มงาน</span>
              <br />
              <b>{{ $moment(quote.startDate).format('LL') }}</b>
            </b-col>
            <b-col sm="12" md="3">
              <span class="text-muted">ระยะเวลางาน</span>
              <br />
              <b>{{ quote.period ? quote.period : '-' }} {{ quote.periodUnit ? quote.periodUnit : '' }}</b>
            </b-col>
            <b-col sm="12" md="3">
              <span class="text-muted">สถานะ</span>
              <br />
              <h5>
                <b-badge
                  :variant="jobStatus.find( x => x.value == quote.status).variant"
                >{{ jobStatus.find( x => x.value == quote.status).text }}</b-badge>
              </h5>
            </b-col>
            <b-col sm="12" md="3">
              <span class="text-muted">วันที่ประกาศ</span>
              <br />
              <b>{{ $moment(quote.createdAt).format('LLL') }}</b>
            </b-col>
            <div class="w-100"></div>
            <b-col sm="12" md="6" align-self="center" class="mt-4">
              <span class="text-muted">ผู้รับผิดชอบงาน</span>
              <b>
                <br />
                <span class="text-logisty-dark-main">{{ quote.contactName }}</span>
                <br />
                <span class="text-logisty-dark-main">{{ quote.contactNumber }}</span>
                <span class="text-logisty-dark-main" v-if="quote.contactEmail">
                  <br />
                  {{ quote.contactEmail }}
                </span>
              </b>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-card>
          <b-row>
            <b-col>
              <h5>เอกสารจากผู้ว่าจ้าง</h5>
              <FileListWithName docType="quote-doc" :refId="quote._id" docClass="request" />
            </b-col>
            <b-col >
              <h5>เอกสารจากผู้ขนส่ง</h5>
              <FileListWithName docType="quote-doc" :refId="quote._id" docClass="response" />
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <ModalLoading />
  </div>
</template>

<script>
import ModalLoading from '../../../components/ModalLoading'

import Quote from '../../../services/http/Quote'

import FileListWithName from '../../../components/FileListWithName'

export default {
  components: {
    ModalLoading,
    FileListWithName
  },
  data () {
    return {
      previewBaseUrl: process.env.VUE_APP_LOGISTY_QUOTE_LINK,
      quote: null,
      jobStatus: [
        { value: '0', text: 'ร่าง', variant: 'info' },
        { value: '2', text: 'รอเผยแพร่', variant: 'info' },
        { value: '5', text: 'เผยแพร่', variant: 'primary' },
        { value: '7', text: 'มีคนส่งเอกสาร', variant: 'primary' },
        { value: '20', text: 'ปิดงาน', variant: 'success' }
      ]
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      Window.Event.$emit('showModalLoading')
      try {
        let quote = new Quote()
        let onequote = await quote.getOneQuote(this.$route.params.quoteId)
        this.quote = onequote.data
      } catch (error) {
        console.log(error)
      }
      Window.Event.$emit('closeModalLoading')
    },
    async closeJob () {
      let quote = new Quote()
      let ret = await quote.updateQuote({
        quoteId: this.$route.params.quoteId,
        status: 20
      })
      if (ret.code === 1) {
        alert('ปิดงานแล้ว')
        this.init()
      } else {
        alert('พบข้อผิดพลาด')
      }
    },
    async openJob () {
      let quote = new Quote()
      let ret = await quote.updateQuote({
        quoteId: this.$route.params.quoteId,
        status: 5
      })
      if (ret.code === 1) {
        alert('เปิดงานแล้ว')
        this.init()
      } else {
        alert('พบข้อผิดพลาด')
      }
    }
  }
}
</script>
